import { render, staticRenderFns } from "./VeritasAppointmentLetterPrint.vue?vue&type=template&id=4893c2b0&scoped=true&"
import script from "./VeritasAppointmentLetterPrint.vue?vue&type=script&lang=js&"
export * from "./VeritasAppointmentLetterPrint.vue?vue&type=script&lang=js&"
import style0 from "./VeritasAppointmentLetterPrint.vue?vue&type=style&index=0&id=4893c2b0&lang=scss&scoped=true&"
import style1 from "./VeritasAppointmentLetterPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893c2b0",
  null
  
)

export default component.exports